import { TextInput } from '@mantine/core';

interface SearchFilterProps {
  label: string;
  description: string;
  value: string;
  setValue: (newValue: string) => void;
  flex?: number;
}

export function SearchFilter(props: SearchFilterProps) {
  const { label, description, setValue, value, flex } = props;
  return (
    <TextInput
      flex={flex}
      label={label}
      description={description}
      placeholder={label}
      value={value}
      onChange={event => setValue(event.currentTarget.value)}
    />
  );
}
